import { action, makeObservable, observable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';
import { CensusGroupDomainDependencies, CensusGroupModule } from 'store/modules/census/group-based/censusGroupModule';
import ICensusUploadPageStore from 'store/modules/census/iCensusUploadPageStore';

export interface CensusMonitorAddEeDomainDependencies extends CensusGroupDomainDependencies {
  cartId: string;
}

export default class CensusMonitorAddEePageStore extends ICensusUploadPageStore<
  CensusMonitorAddEeDomainDependencies,
  CensusGroupModule
> {
  protected _censusModule: CensusGroupModule;
  protected _domainData: CensusMonitorAddEeDomainDependencies;

  public async getCensusData(): Promise<void> {
    this.setIsLoading(true);
    await runInAction(async () => {
      await this._censusModule.getPreviouslyUploadedFiles();
    });
    await runInAction(async () => {
      await this._censusModule.uploadExistingCensus();
    });
    this.setIsLoading(false);
  }

  public onCompleteRedirect(): void {
    bpHistory.push(
      `/census-monitor-add-employees-review/${this._domainData.groupId}?periodId=${this._domainData.enrollmentPeriodId}&cartId=${this._domainData.cartId}`,
    );
  }

  constructor(domainData: CensusMonitorAddEeDomainDependencies) {
    super();
    this._censusModule = new CensusGroupModule({
      enrollmentPeriodId: domainData.enrollmentPeriodId,
      groupId: domainData.groupId,
    });
    this._domainData = domainData;

    makeObservable<CensusMonitorAddEePageStore, '_censusModule' | '_domainData'>(this, {
      _censusModule: observable,
      _domainData: observable,

      getCensusData: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

const CensusMonitorAddEePageStoreContext = createContext(
  new CensusMonitorAddEePageStore({
    enrollmentPeriodId: 'stub-period-id',
    groupId: 'stub-group-id',
    cartId: 'stub-cart-id',
  }),
);

export const useCensusMonitorAddEePageStoreContext = (): CensusMonitorAddEePageStore => {
  return useContext(CensusMonitorAddEePageStoreContext);
};

export { CensusMonitorAddEePageStoreContext };
